











/* General */
import ddIconButton from '@/components/global/buttons/dd-icon-button.vue'
import Vue from 'vue'

/* Mixins */

/* Components */

/* Helpers */

/* Data types */

/* API */

export default Vue.extend({
  name: 'AppHeaderFrillLauncher',
  components: { ddIconButton },
})
